import { CarrierCategoryModel } from './carrierCategoryModel';
import { ActionItemTypeModel } from './ActionItemTypeModel';
import { StateMasterModel } from './stateMasterModel';

export class FavoriteModel {
    carrierCategoryFavorite: CarrierCategoryModel[];
    actionItemTypesFavorite: ActionItemTypeModel[];
    stateFavorite: StateMasterModel[];
}
